<script setup lang="ts">
import { RouterView } from 'vue-router'
import { Toaster } from 'vue-sonner'
import { TooltipProvider, useTheme, useBodyEmbedCode } from '@/shared'
import 'vue-sonner/style.css'

const { initThemeGovernance } = useTheme()

initThemeGovernance()
useBodyEmbedCode()
</script>

<template>
  <TooltipProvider>
    <RouterView />
    <Toaster
      position="bottom-right"
      richColors
      closeButton
      closeButtonPosition="top-right"
      :duration="3000"
      expand
    />
  </TooltipProvider>
</template>
